import { createIcon } from "@chakra-ui/icons";

// Source: https://fontawesome.com/icons/wind?s=solid
export default createIcon({
  displayName: "WindWarning",
  viewBox: "0 0 640 512",
  path: (
    <path
      d="M320 303.1c0-35.28 28.72-64.02 64-64.02h31.37C407.4 134.7 320.6 50.55 212.8 48.06C97.97 45.4 2.713 136.3 .0566 251.2c-2.658 114.8 88.29 210.1 203.1 212.8c75.33 1.744 142-36.93 179.9-96.07C348.2 367.4 320 338.1 320 303.1zM184 152C184 138.8 194.8 128 208 128S232 138.8 232 152v112C232 277.3 221.3 288 208 288S184 277.3 184 264V152zM208 384C190.3 384 176 369.7 176 352c0-17.67 14.33-32 32-32s32 14.33 32 32C240 369.7 225.7 384 208 384zM552 272l-167.1-.0085C366.3 271.1 352 286.3 352 303.1s14.33 32 32 32L552 336c13.23 0 24 10.78 24 24S565.2 384 552 384H512c-17.67 0-32 14.31-32 32s14.33 32 32 32h40c48.53 0 88-39.47 88-88S600.5 272 552 272zM480 240h72C600.5 240 640 200.5 640 152S600.5 64 552 64H512c-17.67 0-32 14.31-32 32s14.33 32 32 32h40C565.2 128 576 138.8 576 152S565.2 176 552 176H480c-17.67 0-32 14.31-32 32S462.3 240 480 240z"
      fill="currentColor"
    />
  ),
});
